export default "__VITE_ASSET__P6oKipTx__"